import { render, staticRenderFns } from "./UsualPowerMigrationConflictNotice.vue?vue&type=template&id=dae97036&"
import script from "./UsualPowerMigrationConflictNotice.vue?vue&type=script&lang=ts&"
export * from "./UsualPowerMigrationConflictNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports